import React, { useCallback, ReactElement, cloneElement, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import DefaultCreateGoalButton from './DefaultCreateGoalButton/DefaultCreateGoalButton';
import CreateGoalModal from 'Dashboard/components/CreateOrUpdateGoalPageV3/CreateGoalModal';

type Props = {
  children?: ReactElement;
  disabled?: boolean;
};

function CreateGoalButtonContainer({ children = <DefaultCreateGoalButton />, ...rest }: Props) {
  const history = useHistory();
  const { featureFlagGoalsVersion3: showNewGoals } = useFlags();

  const [isOpen, toggleIsOpen] = useToggle(false);

  const handleCreateGoalFlowOpen = useCallback(() => {
    if (showNewGoals) toggleIsOpen();
    else {
      history.push(PageUrlsConstants.GOALS_NEW_PAGE);
    }
  }, [history]);

  return (
    <>
      {cloneElement(children, { onClick: handleCreateGoalFlowOpen, ...rest })}
      <CreateGoalModal isOpen={isOpen} toggleIsOpen={toggleIsOpen} />
    </>
  );
}

export default memo(CreateGoalButtonContainer);
